// import zod schemas
import { CompanyDetailsBasicsStep } from "@/components/onboarding/steps/CompanyDetailsBasicsStep";
import { CompanyDetailsStatisticsStep } from "@/components/onboarding/steps/CompanyDetailsStatisticsStep";
import { CompanySearchStep } from "@/components/onboarding/steps/CompanySearchStep";
import { CompanySelectionStep } from "@/components/onboarding/steps/CompanySelectionStep";
import { CreateReboltAccountStep } from "@/components/onboarding/steps/CreateReboltAccountStep";
import { FinalReviewStep } from "@/components/onboarding/steps/FinalReviewStep";
import { ReboltGoalsStep } from "@/components/onboarding/steps/ReboltGoalsStep";

import type { OnboardingStepConfig } from "@/types/onboarding";

const BACKGROUND_IMAGE = "/onboarding/seo-brushes.jpg";

// step configuration
export const onboardingSteps = [
  {
    id: "create-rebolt-account",
    component: CreateReboltAccountStep,
    allowBack: false,
    isOptional: false,
  },
  {
    id: "company-search",
    image: BACKGROUND_IMAGE,
    component: CompanySearchStep,
    allowBack: false,
    isOptional: false,
  },
  {
    id: "company-selection",
    image: BACKGROUND_IMAGE,
    component: CompanySelectionStep,
    allowBack: true,
    isOptional: true,
  },
  {
    id: "company-details-basics",
    image: BACKGROUND_IMAGE,
    component: CompanyDetailsBasicsStep,
    allowBack: true,
    isOptional: false,
  },
  {
    id: "company-details-statistics",
    image: BACKGROUND_IMAGE,
    component: CompanyDetailsStatisticsStep,
    allowBack: false,
    isOptional: true,
  },
  {
    id: "rebolt-goals",
    image: BACKGROUND_IMAGE,
    component: ReboltGoalsStep,
    isOptional: true,
    allowBack: true,
  },
  {
    id: "final-review",
    image: BACKGROUND_IMAGE,
    component: FinalReviewStep,
    allowBack: false,
    isOptional: false,
  },
] as const satisfies readonly OnboardingStepConfig[];

// only allow existing step ids
export type StepIdName = (typeof onboardingSteps)[number]["id"];

// helper to get step index by id (returns -1 if not found)
export function getStepIndex(stepId: StepIdName): number {
  return onboardingSteps.findIndex((step) => step.id === stepId);
}

export const STEP_INDICES = {
  CREATE_REBOLT_ACCOUNT: getStepIndex("create-rebolt-account"),
  SEARCH_USER_BUSINESS: getStepIndex("company-search"),
  CREATE_REBOLT_BUSINESS: getStepIndex("company-details-basics"),
} as const;
